<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    Refrigerant Health
                </v-card-title>
                <v-card-text>
                    <date-range-selector v-model="range"></date-range-selector>
                    <v-switch
                            v-model="onOnly"
                            label="View Points when Chiller is On"
                    ></v-switch>
                </v-card-text>
                <v-card-text>
                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            variable-x="Cond_Sat_Refrig_Temp"
                            variable-y="Cond_Sat_Refrig_Temp"
                            :on-only="onOnly"
                            type="histogram"
                    ></refrigerant-temp-pressure-plot>

                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            variable-x="Refrigerant_Temp"
                            variable-y="Refrigerant_Temp"
                            :on-only="onOnly"
                            type="histogram"
                    ></refrigerant-temp-pressure-plot>

                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            :on-only="onOnly"
                    ></refrigerant-temp-pressure-plot>
                    <refrigerant-temp-pressure-plot
                            :date-range="range"
                            variable-x="Cond_Sat_Refrig_Temp"
                            variable-y="Cond_Sat_Refrig_Press"
                            :on-only="onOnly"
                    ></refrigerant-temp-pressure-plot>

                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import RefrigerantTempPressurePlot from '../../components/faults/RefrigerantTempPressurePlot'
  import DateRangeSelector from '../../components/DateRangeSelector'
  export default {
    name: 'RefrigerantHealth',
    components: { DateRangeSelector, RefrigerantTempPressurePlot },
    data () {
      return {
        range: null,
        onOnly: true
      }
    }
  }
</script>

<style scoped>

</style>
